export function setPledgePayDetailsExpanded(section, expanded) {
    if (!section) {
        return;
    }
    section.querySelector('.mgr-pledge-gateway-body').hidden = !expanded;
    section.querySelector('.mgr-pledge-gateway-toggle').setAttribute('aria-expanded', String(expanded));
}
